module.exports = __webpack_public_path__ + "img/hampton-logo.c4b34cf0.jpg";